<template>
<div id='diagram-buton' class='h-toolbarBg'>
    <ejs-toolbar>
        <e-items>
          <e-item :click="notices" eventType='saveLocBtn' v-if="saveLocBtn" :tooltipText='$t("Topo.saveTopo")' prefixIcon='icon hero-icon hero-icon-save'></e-item>
          <e-item :click="notices" eventType='excelLayout' v-if="layoutBtn" :tooltipText='$t("Topo.excelLayout")' prefixIcon='icon hero-icon hero-icon-layout'></e-item>
          <e-item :click="notices" eventType='revertScale' v-if="revertBtn" :tooltipText='$t("Topo.revertScale")' prefixIcon='icon hero-icon hero-icon-original-scale'></e-item>
          <e-item :click="notices" eventType='fullScreen' v-if="fullScreenBtn" :tooltipText='$t("Topo.fullScreen")' :prefixIcon='fullScreenIcon'></e-item>
          <e-item :click="notices" eventType='selectAll' v-if="selectAllBtn" :tooltipText='$t("Topo.selectAll")' prefixIcon='icon hero-icon hero-icon-Batch-select'></e-item>
          <e-item :click="notices" eventType='backPrevious' v-if="backPreBtn" :tooltipText='$t("Topo.backPrevious")' prefixIcon='icon hero-icon hero-icon-previous-layer'></e-item>
          <e-item :click="notices" eventType='refresh' v-if="refreshBtn" :tooltipText='$t("Alarm.refresh")' prefixIcon='icon hero-icon hero-icon-refresh'></e-item>
        </e-items>
    </ejs-toolbar>
    <div class="topo-alarm-all"  :style="styleColorVar" v-if='showAlarmNumBtn'>
	      	<span>{{$t('Alarm.alarm')}}:</span>
          <!-- @click="alarmShowOperation"  	 -->
	      	<a  style="color:dddddd;"><span class="h-icon h-icon-dot critical radius50" ></span>{{Level0AlarmCount}}</a>
	      	<a style="color:dddddd;"><span class="h-icon h-icon-dot major radius50"></span>{{Level1AlarmCount}}</a>
	      	<a  style="color:dddddd;"><span class="h-icon h-icon-dot minor radius50" ></span>{{Level2AlarmCount}}</a>
	      	<a  style="color:dddddd;"><span class="h-icon h-icon-dot warning radius50"></span>{{Level3AlarmCount}}</a>
      </div>
</div>
</template>

<script>
	import { EventBus } from '../../plugins/eventBus';

export default {
    name: 'button-graph',
    props: {
      saveLocBtn: { type: Boolean, default: false },
      layoutBtn: { type: Boolean, default: false },
      revertBtn: { type: Boolean, default: false },
      fullScreenBtn: { type: Boolean, default: false },
      selectAllBtn: { type: Boolean, default: false },
      backPreBtn: { type: Boolean, default: false },
      refreshBtn: { type: Boolean, default: false },
      // roleNe: {
      //   type: Array,
      //   default() {
      //     return [];
      //   }
      // }
    },

    data(){
      return{
        roleNe:[],
        flag:1,
        Level0AlarmCount: 0,
		    Level1AlarmCount: 0,
		    Level2AlarmCount: 0,
        Level3AlarmCount: 0,
        showAlarmNumBtn: { type: Boolean, default: true },
        styleColorVar:{},
      }
    },
    computed:{
      fullScreenIcon(){
        let icon = '';
        if(this.flag){
          icon = 'icon hero-icon hero-icon-full-screen';
        }else{
          icon = 'icon hero-icon hero-icon-Cancel-full-screen';
        }
        return icon;
      }
    },
    methods: {
        notices(args) {
            this.$emit('notice', args.item.eventType);
        },
        queryAlarmNum(){
          let principal = sessionStorage.getItem('principal');
          let user = JSON.parse(principal);
          let userId = user.userId;
          this.$axios.post('/lte/ems/fm/alarmcurrent/alarmCount', {
            conditions: "",
            keywords: "",
            userId:userId,
            roleNe: JSON.parse(JSON.stringify(this.roleNe))
          }).then((response) => {
            // console.log("This.roleNe after",this.roleNe);
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              this.Level0AlarmCount = response.data.resultVal.alarmCountInfo.criticalAlarmCount;
              this.Level1AlarmCount = response.data.resultVal.alarmCountInfo.majorAlarmCount;
              this.Level2AlarmCount = response.data.resultVal.alarmCountInfo.minorAlarmCount;
              this.Level3AlarmCount = response.data.resultVal.alarmCountInfo.warningAlarmCount;

            }
          });
        },
        queryTopoConfig(roleNe){
          this.roleNe = roleNe;
          const url = "";
          this.axios.get(`/lte/ems/sysmanager/systemtopoconfig/querySystemTopoConfig`).then(response => {
            if (response && response.status === 200) {
              if(0==response.data.resultVal[0].alarmNumSet){
                this.showAlarmNumBtn = false;
              }else{
                this.showAlarmNumBtn = true;
                this.queryAlarmNum();

              }
            }
          })
        }
    },
    mounted() {
      this.styleColorVar = JSON.parse(localStorage.getItem('styleColorVar'));
      // console.log(this.$parent.$parent.$refs.physicGraph.queryTopoConfig());
      // this.queryTopoConfig();
    },

}
</script>
<style>
div.topo-alarm-all
{
	float: right;
  width: 30%;
  padding: 0 0 0 12px;
  color: #dddddd;
  text-align:right;
}

.topo-alarm-all a
{
	margin: 0 10px 0 10px;
	color: #dddddd;
	/* cursor: pointer; */
	text-decoration: underline;
}

.topo-alarm .radius50
{
	width: 10px !important;
    height: 10px !important;
    border-radius: 50%;
}
</style>
